var map = {
	"./de_DE.json": 1116,
	"./en_AU.json": 1117,
	"./en_CA.json": 1118,
	"./en_GB.json": 1119,
	"./es_AR.json": 1120,
	"./es_ES.json": 1121,
	"./es_MX.json": 1122,
	"./fr_CA.json": 1123,
	"./fr_FR.json": 1124,
	"./it_IT.json": 1125,
	"./nl_NL.json": 1126,
	"./pt_BR.json": 1127,
	"./pt_PT.json": 1128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1115;